import React from 'react';
import { useTranslation } from 'react-i18next';

const PolishFlag = () => (
  <svg viewBox="0 0 60 40" width="22" height="14" aria-hidden="true">
    <rect width="60" height="20" fill="#FFFFFF" />
    <rect y="20" width="60" height="20" fill="#DC143C" />
    <rect x="0.5" y="0.5" width="59" height="39" fill="none" stroke="rgba(255,255,255,0.18)" />
  </svg>
);

const UKFlag = () => (
  <svg viewBox="0 0 60 40" width="22" height="14" aria-hidden="true">
    <clipPath id="hussar-uk-clip">
      <rect width="60" height="40" />
    </clipPath>
    <g clipPath="url(#hussar-uk-clip)">
      <rect width="60" height="40" fill="#012169" />
      {/* White diagonals */}
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#FFFFFF" strokeWidth="8" />
      {/* Red diagonals (St Patrick) */}
      <path d="M0,0 L60,40" stroke="#C8102E" strokeWidth="4" clipPath="polygon(0 0, 50% 50%, 100% 100%)" />
      <path d="M0,0 L60,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M60,0 L0,40" stroke="#C8102E" strokeWidth="4" />
      {/* White cross (St George background) */}
      <path d="M30,0 V40 M0,20 H60" stroke="#FFFFFF" strokeWidth="10" />
      {/* Red cross (St George) */}
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="6" />
    </g>
    <rect x="0.5" y="0.5" width="59" height="39" fill="none" stroke="rgba(255,255,255,0.18)" />
  </svg>
);

const FlagToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'pl';

  const setLang = (lng) => {
    if (lng !== current) {
      i18n.changeLanguage(lng);
    }
  };

  return (
    <div className={`hussar-flag-toggle ${className}`} role="group" aria-label="Language">
      <button
        type="button"
        onClick={() => setLang('pl')}
        className={`hussar-flag-btn ${current.startsWith('pl') ? 'is-active' : ''}`}
        aria-pressed={current.startsWith('pl')}
        title="Polski"
        data-testid="lang-toggle-pl"
      >
        <PolishFlag />
        <span className="hussar-flag-label">PL</span>
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`hussar-flag-btn ${current.startsWith('en') ? 'is-active' : ''}`}
        aria-pressed={current.startsWith('en')}
        title="English (UK)"
        data-testid="lang-toggle-en"
      >
        <UKFlag />
        <span className="hussar-flag-label">EN</span>
      </button>
    </div>
  );
};

export default FlagToggle;
